import {
  Link,
  Stack,
  StackProps as StackPropsType,
  Typography,
  TypographyProps as TypographyPropsType,
} from '@mui/material';
import { Link as RouterLink } from 'react-router';
import { getRouterPathToAuthor } from '../../utilities/Links';

interface AuthorListProps {
  readonly authors?: string[];
  readonly variant?: TypographyPropsType['variant'];
  readonly StackProps?: StackPropsType;
  readonly TypographyProps?: TypographyPropsType;
  readonly onClick?: () => void;
}

export default function AuthorList({
  authors = [],
  variant = 'overline',
  StackProps,
  TypographyProps,
  onClick = () => {},
}: AuthorListProps) {
  return (
    <Stack
      direction='row'
      component={Typography}
      sx={{ color: 'text.secondary', flexWrap: 'wrap' }}
      {...StackProps}
    >
      {authors?.map((author, i) => [
        i > 0 && (
          <Typography
            key={'author-list-comma-' + i}
            component='span'
            variant={variant}
            {...TypographyProps}
            sx={[
              {
                marginRight: 0.5,
              },
              ...(Array.isArray(TypographyProps?.sx)
                ? TypographyProps.sx
                : [TypographyProps?.sx]),
            ]}
          >
            ,
          </Typography>
        ),
        <Link
          key={'author-' + author}
          component={RouterLink}
          to={getRouterPathToAuthor(author)}
          onClick={() => onClick()}
          underline='hover'
          sx={{
            color: 'secondary',
            display: 'block',
            flexWrap: 'nowrap',
          }}
          variant={variant}
          {...TypographyProps}
        >
          {author}
        </Link>,
      ])}
    </Stack>
  );
}
